import { useMemo } from "react";
import { getAccountChargesByUser, useQuery } from "wasp/client/operations";
import { Card, CardContent } from "../../../client/components/ui/card";
import { CardSectionHeader } from "../../../client/components/ui/card-section-header";
import AccountChargesManager from "../../../trading-accounts/AccountChargesManager";
import useTranslation from "../../../client/hooks/useTranslation";

export default function PropFirmGlobalChargesWidget() {
  const t = useTranslation();
  const { data: chargesData, refetch: refetchCharges } = useQuery(getAccountChargesByUser);
  const charges = chargesData ?? [];
  const globalCharges = useMemo(() => charges.filter((c: any) => c.accountId === null), [charges]);

  return (
    <Card className="h-full flex flex-col">
      <CardSectionHeader label={t.analytics.payoutsGlobalCharges} isDark={false} compact />
      <CardContent className="flex-1 overflow-auto p-4">
        <AccountChargesManager
          charges={globalCharges}
          accountId={null}
          onMutated={() => refetchCharges()}
        />
      </CardContent>
    </Card>
  );
}
